import React from "react";
import ConfigSection from "../../ConfigSection";

const JobRoleSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Job Role'
      configType='JobRole'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default JobRoleSection;
